import PropTypes from 'prop-types';

export const BookToTaxDifferencePropTypes = PropTypes.shape({
  periodName: PropTypes.string,
  exceptionId: PropTypes.number,
  description: PropTypes.string,
  enabledFlag: PropTypes.string.isRequired,
  exceptionAccount: PropTypes.string,
  countryTaxType: PropTypes.string,
  exceptionBasis: PropTypes.string,
  disallowedPercentage: PropTypes.string,
  deferredTaxAccount: PropTypes.string,
  tagDescription: PropTypes.string,
  importStatusDetail: PropTypes.string,
  importValidation: PropTypes.string,
});

export const BookToTaxDifferencesPropTypes = PropTypes.arrayOf(BookToTaxDifferencePropTypes).isRequired;

export const BookToTaxDifferencesCollectionPropTypes = PropTypes.arrayOf(PropTypes.shape({
  countryTaxType: PropTypes.string,
  description: PropTypes.string,
  account: PropTypes.string,
  bookType: PropTypes.string,
  begAmount: PropTypes.number,
  ytdAmount: PropTypes.number,
  disallowedPer: PropTypes.number,
  disallowedAmt: PropTypes.number,
}));
